import { featureLinkInputs } from "../feature-link/inputs";

const IMAGE_TYPES = ["jpeg", "png", "svg", "webp", "gif"];
const DESKTOP_IMAGE =
  "https://cdn.builder.io/api/v1/image/assets%2F1e07bd57fd054601b600816e06494849%2Fbd19365567d54205ab5ba87192af07f2";
const MOBILE_IMAGE =
  "https://cdn.builder.io/api/v1/image/assets%2F1e07bd57fd054601b600816e06494849%2F994d170fb76148b9becd0be24a0cccf2";

const defaultItem = {
  desktopImage: DESKTOP_IMAGE,
  mobileImage: MOBILE_IMAGE,
  label: "<p>Best Sellers</p>",
  whiteText: true,
};

/** Builder inputs for Featured 3-Up — the symbol's inputs plus the CTA link. */
export const featuredThreeUpInputs = [
  {
    name: "heading",
    friendlyName: "Heading",
    type: "text",
    required: true,
    defaultValue: "Featured",
  },
  {
    name: "items",
    friendlyName: "Featured items",
    type: "list",
    required: true,
    helperText:
      "Three per row on desktop. A 4th item or more wraps onto a new, centered row.",
    defaultValue: [defaultItem, defaultItem, defaultItem],
    subFields: [
      {
        name: "desktopImage",
        friendlyName: "Desktop image",
        type: "file",
        allowedFileTypes: IMAGE_TYPES,
        required: true,
        helperText: "Also used on tablet. Decorative: no alt text.",
      },
      {
        name: "mobileImage",
        friendlyName: "Mobile image",
        type: "file",
        allowedFileTypes: IMAGE_TYPES,
        required: true,
      },
      { name: "label", friendlyName: "Label", type: "html" },
      {
        name: "whiteText",
        friendlyName: "White text",
        type: "boolean",
        defaultValue: true,
        helperText: "On for white text and arrow, off for dark blue.",
      },
      ...featureLinkInputs,
    ],
  },
];
